import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

const ViewInvoices = ({openModal, setInvoiceData, userInvoiceData}) => {

  const invoiceStatuses = {
    'BILLING.SUBSCRIPTION.ACTIVATED': 'Activated',
    'PAYMENT.SALE.COMPLETED': 'Paid',
    'BILLING.SUBSCRIPTION.FAILED': 'Failed',
    'BILLING.SUBSCRIPTION.CANCELLED': 'Cancelled',
    'BILLING.SUBSCRIPTION.EXPIRED': 'Expired',
  }

    // const invoices = [
    //     {
    //       id: 'INV-1A2B3C4D',
    //       type: 'Basic',
    //       date: '2024-11-12',
    //       amount: 10.00,
    //       paymentMethod: 'PayPal',
    //       status: 'Successful',
    //     },
    //     {
    //       id: 'INV-5E6F7G8H',
    //       type: 'Standard',
    //       date: '2024-11-12',
    //       amount: 15.00,
    //       paymentMethod: 'Credit',
    //       status: 'Successful',
    //     },
    //     {
    //       id: 'INV-9I0J1K2L',
    //       type: 'Premium',
    //       date: '2024-11-12',
    //       amount: 20.00,
    //       paymentMethod: 'Debit',
    //       status: 'Failed',
    //     },
    //     {
    //       id: 'INV-3M4N5O6P',
    //       type: 'Basic',
    //       date: '2024-11-12',
    //       amount: 10.00,
    //       paymentMethod: 'Credit',
    //       status: 'Denied',
    //     },
    //     {
    //       id: 'INV-7Q8R9S0T',
    //       type: 'Standard',
    //       date: '2024-11-12',
    //       amount: 15.00,
    //       paymentMethod: 'PayPal',
    //       status: 'Successful',
    //     },
    //     {
    //       id: 'INV-1U2V3W4X',
    //       type: 'Premium',
    //       date: '2024-11-12',
    //       amount: 20.00,
    //       paymentMethod: 'Debit',
    //       status: 'Successful',
    //     },
    //     {
    //       id: 'INV-5Y6Z7A8B',
    //       type: 'Basic',
    //       date: '2024-11-12',
    //       amount: 10.00,
    //       paymentMethod: 'PayPal',
    //       status: 'Failed',
    //     },
    //     {
    //       id: 'INV-9C0D1E2F',
    //       type: 'Standard',
    //       date: '2024-11-12',
    //       amount: 15.00,
    //       paymentMethod: 'Credit',
    //       status: 'Successful',
    //     },
    //     {
    //       id: 'INV-3G4H5I6J',
    //       type: 'Premium',
    //       date: '2024-11-12',
    //       amount: 20.00,
    //       paymentMethod: 'Debit',
    //       status: 'Denied',
    //     },
    // ];


  return (
    <div className='mt-4'>
      <h4>Invoice History</h4>
      <hr />
      {userInvoiceData.length === 0 ? (
        <p style={{color: "#AEAFBA", fontSize: "15px"}}>No invoices found.</p>
      ) : (
        <div className='d-flex flex-column mt-2'>
          <div
            className='invoice-row'
          >
            {/* Type Column */}
            <p className='m-0 invoice-type' style={{fontWeight: 600}}>Type</p>
            
            {/* Date Column */}
            <p className='m-0 invoice-date' style={{fontWeight: 600}}>Date</p>

            {/* Note Column */}
            <p className='m-0 invoice-status d-none d-md-block' style={{fontWeight: 600}}>Status</p>

            {/* Amount Column */}
            <div className='invoice-amount d-none d-lg-flex'>
              <p className='m-0 me-1' style={{fontWeight: 600}}>Amount</p>
            </div>
          </div>

          {userInvoiceData.map((invoice) => (
            <div
              key={invoice.id}
              className='invoice-row'
              onClick={() => {
                  // Set the selected invoice data
                  setInvoiceData(invoice);
                  openModal('invoiceDetails');
              }}
            >
              {/* Type Column */}
              <p className='m-0 invoice-type'>{invoice.purchaseType.startsWith("C") ? "Contribution" : "Subscription"}</p>

              {/* Date Column */}
              <p className='m-0 invoice-date'>{invoice?.createdDate.split("T")[0]}</p>

              {/* Note Column */}
              <p className='m-0 invoice-status d-none d-md-block'>{invoice?.paymentStatus}</p>

              {/* Amount Column */}
              <div className='invoice-amount d-none d-lg-flex'>
                <p className='m-0 me-1'>${invoice.paymentAmount ? invoice.paymentAmount : 0.00}</p>
                <FontAwesomeIcon
                  icon={faChevronRight}
                  style={{ color: '#AEAFBA' }}
                />
              </div>

            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ViewInvoices